import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  textIput: {
    flex: 1,
    textAlignVertical: 'center',
  },
  passwordContainer: {
    width: 60,
    height: 50,
  },
});
